import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { dayMaxFe, filterActivities, CHALLENGE_TYPES, OPINION_TYPES } from './dailyTasksUtils';

function GroupBlock({ title, items, emptyLabel }) {
  return (
    <Box mb={2}>
      <Typography variant="subtitle1" gutterBottom>
        {title}{' '}
        <Chip size="small" label={items.length} sx={{ ml: 0.5 }} />
      </Typography>
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyLabel}
        </Typography>
      ) : (
        items.map((item, idx) => (
          <Box
            key={item.id || item.task_key || idx}
            sx={{
              p: 1.5,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" fontWeight={600}>
              {item.title || item.label || 'Untitled'}
            </Typography>
            {(item.subtitle || item.action_key) && (
              <Typography variant="caption" color="text.secondary" display="block">
                {item.subtitle || item.action_key}
              </Typography>
            )}
            {item.activity_type && (
              <Chip size="small" label={item.activity_type} sx={{ mt: 0.5 }} />
            )}
          </Box>
        ))
      )}
    </Box>
  );
}

function DayPreviewDrawer({ open, onClose, loading, preview, dayConfig, mission, activities }) {
  const payload = preview || {};
  const groups = payload.groups || null;
  const missionTasks =
    groups?.missions?.tasks ||
    mission?.tasks ||
    [];
  const challenges =
    groups?.challenge?.activities ||
    filterActivities(activities || payload.activities, CHALLENGE_TYPES);
  const opinions =
    groups?.opinions?.activities ||
    filterActivities(activities || payload.activities, OPINION_TYPES);
  const available = dayConfig ? dayMaxFe(dayConfig) : payload.available_fe;

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 400, p: 2 } }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">App preview</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Typography variant="caption" color="text.secondary" display="block" mb={2}>
        App preview (no user progress). Recommend a separate “Open as fan” QA hit on{' '}
        <code>GET /dailies/today</code> with a test token.
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Chip
            color="primary"
            label={`Available today: ${available ?? '—'} FE`}
            sx={{ mb: 2 }}
          />
          <Divider sx={{ mb: 2 }} />
          <GroupBlock title="Missions" items={missionTasks} emptyLabel="No missions" />
          <GroupBlock title="Challenge" items={challenges} emptyLabel="No challenges" />
          <GroupBlock title="Opinions" items={opinions} emptyLabel="No opinions" />
        </>
      )}
    </Drawer>
  );
}

export default DayPreviewDrawer;
